import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

const StyledImageContainer = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };
});

interface IImageProps extends PropsWithChildren {
  className?: string;
}

export const Image = ({
  className,
  children,
}: IImageProps) => {
  return (
    <StyledImageContainer className={className}>{children}</StyledImageContainer>
  );
};
